<p>dashboard-sso works!</p>
